import request from "./request";

export const appointmentApi = {
  addOne: async (params) => request.post("/appointment/add", params),
  sendVerifyCode: async (params) =>
    request.get("/wxUser/sendVerifyCode", params),
};

export const sectionApi = {
  getList: async (params) => request.get("/section/list", params),
};

export const doctorApi = {
  getList: async (params) => request.get("/doctor/list", params),
};

export const scheduleApi = {
  getList: async (params) => request.get("/doctorSchedule/list", params),
};

export const articleApi = {
  getList: async (params) => request.get("/article/list", params),
  getInfo: async (params) => request.get("/article/getInfo", params),
  statistics: async (params) => request.put("/article/statistics", params),
};

export const visitApi = {
  addVisitLog: async (params) => request.post("/visit/log", params),
};

export const systemApi = {
  getByKey: async (params) => request.post("/config/getByKey", params),
};
